let server =
  "https://ygc61e34u9.execute-api.us-east-1.amazonaws.com/analytics";
module.exports = server;
